import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { useSnapshot } from 'valtio';
import AccordionCategoryItem from '../AccordionCatergoryItem/AccordionCatergoryItem';
import ProfileStore from '../../store/profiles';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import { range } from 'lodash';

const CatergoriesAccordion: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { categories, policiesPerCategoriesInfo } = useSnapshot(ProfileStore);
  const { loadingProfileOverview } = useSnapshot(PoliciesProfileUIStateStore);

  return (
    <Stack flexGrow={1} direction='column'>
      {!loadingProfileOverview ? (
        categories.map(category => (
          <AccordionCategoryItem
            key={category.id}
            category={category}
            categoriesInfo={policiesPerCategoriesInfo.find(
              CategoriesInfo => CategoriesInfo.id === category.id,
            )}
          />
        ))
      ) : (
        <Box>
          {range(1, 8).map((_, index) => (
            <Skeleton height={65} key={index} animation='wave' />
          ))}
        </Box>
      )}
    </Stack>
  );
};

export default CatergoriesAccordion;
